import { render, staticRenderFns } from "./MenuOverlay.vue?vue&type=template&id=bcad6972&scoped=true&"
import script from "./MenuOverlay.vue?vue&type=script&lang=js&"
export * from "./MenuOverlay.vue?vue&type=script&lang=js&"
import style0 from "./MenuOverlay.vue?vue&type=style&index=0&id=bcad6972&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcad6972",
  null
  
)

export default component.exports